import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { BusinessPageCombinedState, BusinessPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { BusinessPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<BusinessPageCombinedState> };

type Props = {
	prefetchedData: BusinessPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const BusinessPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return <BusinessPageDataContextProvider pageData={pageData}>{children}</BusinessPageDataContextProvider>;
};
